import React, { useState, useRef, useEffect, useMemo } from "react";

/** Components */
import { TextField, TableContainer, TableHead, TableRow, TableCell, Button, Table, TableBody, Dialog, ButtonGroup, Paper } from "@mui/material";
import { FilterBy } from "../../../commons/filter.component";
import ButtonWithAPICallComponent from "../../../commons/ButtonWithAPICall.component";
import TicketPreview from "../../commons/ticketPreview.component";
import CustomDatePicker from "../../../commons/CustomDatePicker";
/** Icons */

/** Api & Function */
import { getTank, getInventory, getInvoiceForm, getVehicle, getLoadingType, getProductUnit, createB5, editTicket, getProduct, getSTP } from "../../../../services/api";
import { setHeaderTitle } from "../../../../store/layoutSlide";

/** Package */
import moment from "moment";

/** Hook */
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";

const initialProduct = {
  quantity: "",
  unit: null,
  temp: "",
  d15: "",
  vcf: "",
  wcf: "",
  kg: "",
  l15: "",
};
const CreateB5 = ({ initialData }) => {
  // boiler plate
  const { enqueueSnackbar } = useSnackbar();
  const [t] = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  // redux state
  const user = useSelector((state) => state.user.data);

  // state
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [inputData, setInputData] = useState({
    startdate: moment(Date.now()).format("YYYY-MM-DD HH:mm"),
    enddate: moment(Date.now()).format("YYYY-MM-DD HH:mm"),
    billdate: moment(Date.now()).format("YYYY-MM-DD HH:mm"),
    invoiceForm: null,
    inventory_cert: "",
    driver: null,
    from_inventory: null,
    to_inventory: null,
    vehicle: null,
    orderno: "",
    receiptproducts: location.state ? [] : [{ ...initialProduct }],
    contract_date: "",
    contract_no: "",
    loadingtype: null,
    billcode: "",
    product: null,
    stp: null,
    tank: null,
    exp_note: "",
  });
  const dataForPreview = useMemo(() => {
    return {
      receipt: {
        ...inputData,
        date: inputData.startdate,
        form_no: inputData.invoiceForm?.form,
        serial: inputData.invoiceForm?.series,
        driver: inputData.driver,
        license_plate: inputData.vehicle?.license_plate,
        from_inventory_name: inputData.from_inventory?.name,
        to_inventory_name: inputData.to_inventory?.name,
        receiptproducts: undefined,
      },
      receiptproduct: inputData.receiptproducts.map((item) => ({
        ...item,
        lit: parseFloat(item.quantity),
        product_name: inputData.product?.name,
      })),
    };
  }, [inputData]);

  const handleSubmit = () => {
    let object = {
      ...inputData,
      loadingtype_id: inputData.loadingtype?.id,
      exp_tank_id: inputData.tank?.id,
      exp_tank_code: inputData.tank?.code,
      exp_inventory_id: inputData.from_inventory?.id,
      exp_inventory_code: inputData.from_inventory?.name,
      imp_inventory_id: inputData.to_inventory?.id,
      imp_inventory_code: inputData.to_inventory?.name,
      vehicle_id: inputData.vehicle?.id,
      vehicle_no: inputData.vehicle?.license_plate,
      provider_name: inputData.vehicle?.owner_company,
      provider_id: inputData.vehicle?.provider_id,
      driver: inputData.driver,

      product_id: inputData.product?.id,
      product_name: inputData.product?.name,

      exp_start_pump: moment(inputData.startdate).format("YYYY-MM-DD HH:mm"),
      exp_end_pump: moment(inputData.enddate).format("YYYY-MM-DD HH:mm"),
      billdate: moment(inputData.billdate).format("YYYY-MM-DD HH:mm"),
      exp_order_no: inputData.orderno,
      exp_cert_no: inputData.inventory_cert,

      contract_date: inputData.contract_date ? moment(inputData.contract_date).format("YYYY-MM-DD HH:mm") : undefined,
      serial: inputData.invoiceForm?.series,
      form_no: inputData.invoiceForm?.form,
      exp_note: inputData.exp_note,

      receiptproducts: inputData.receiptproducts.map((item) => ({ ...item, unit_id: item.unit.id, product_name: inputData.product?.name })),
    };
    if (!location.state) return createB5(object);
    else return editTicket(location.state.receipt.id, object);
  };
  const handleResponse = (res) => {
    res.code === 200 && history.push("/b5");
  };
  const isSubmitDisabled = useMemo(() => {
    if (
      !inputData.invoiceForm ||
      !inputData.startdate ||
      !inputData.enddate ||
      !inputData.billdate ||
      // || !inputData.driver
      !inputData.billcode ||
      !inputData.to_inventory ||
      !inputData.vehicle ||
      !inputData.orderno ||
      // || !inputData.saletype
      !inputData.loadingtype ||
      !inputData.inventory_cert ||
      inputData.receiptproducts.find(
        (item) => item.loadingState || item.temp_error || item.d15_error || !item.quantity || !item.d15 || !item.temp || !item.unit || !item.vcf || !item.wcf || !item.kg || !item.l15
      )
    )
      return true;
    return false;
  }, [inputData]);
  // effect
  useEffect(() => {
    if (!inputData.from_inventory) return;
    if (inputData.from_inventory.tanks?.length === 0) enqueueSnackbar(`Kho xuất ${inputData.from_inventory.name} chưa được khai báo thông tin bồn/bể`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData.from_inventory]);

  useEffect(() => {
    dispatch(setHeaderTitle("TẠO MỚI PHIẾU XUẤT KHO KIÊM VẬN CHUYỂN NỘI BỘ TÀU THUỶ"));
    if (location.state) {
      setInputData((prev) => ({
        ...prev,
        orderno: location.state.receipt.orderno,
        billdate: location.state.receipt.billdate && moment(location.state.receipt.billdate).format("YYYY-MM-DD[T]HH:mm"),
        startdate: location.state.receipt.startdate && moment(location.state.receipt.startdate).format("YYYY-MM-DD[T]HH:mm"),
        enddate: location.state.receipt.enddate && moment(location.state.receipt.enddate).format("YYYY-MM-DD[T]HH:mm"),
        contract_date: location.state.receipt.contract_date && moment(location.state.receipt.contract_date).format("YYYY-MM-DD[T]HH:mm"),
        billcode: location.state.receipt.billcode,
        inventory_cert: location.state.receipt.inventory_cert,
        contract_no: location.state.receipt.contract_no,
        receiptproducts: JSON.parse(JSON.stringify(location.state.receiptproduct)),
        // receiptproducts: JSON.parse(JSON.stringify(location.state.receiptproduct)).map(item => ({ ...item, tank: JSON.parse(item.tank) })),
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // render
  return (
    <Paper style={{ margin: 5, marginTop: 10 }}>
      <div style={{ margin: 5, width: "98%", display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gridGap: 20 }}>
        <FilterBy
          label={t("Mẫu phiếu vận chuyển nội bộ")}
          getDataFunc={() => user && getSTP({ org_id: user?.organization_id, status: 1, date: inputData.date })}
          getDataDependencies={[user]}
          setDefaultFunc={(option) => location.state && setInputData((prev) => ({ ...prev, stp: option.find((item) => item.id === location.state.receipt.stp_id) || null }))}
          triggerSetDefaultFunc={true}
          value={inputData.stp}
          onChange={(e, newValue) => setInputData((prev) => ({ ...prev, stp: newValue, receiptproducts: prev.receiptproducts.map((item) => ({ ...item, tank: null })) }))}
          getOptionLabel={(option) => `${option.id} - ${option.code}` || ""}
        />
        <FilterBy
          getDataFunc={() => getInventory({ status: 1 })}
          setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, from_inventory: option.find((item) => item.id === prev.stp?.from_inventory_id) }))}
          triggerSetDefaultFunc={true}
          setDefaultDependencies={[inputData.stp]}
          value={inputData.from_inventory}
          label={t("Kho xuất")}
          onChange={(e, newValue) => setInputData((prev) => ({ ...prev, from_inventory: newValue, receiptproducts: prev.receiptproducts.map((item) => ({ ...item, tank: null })) }))}
          disabled
        />
        <FilterBy
          label={t("Bồn/Bể xuất")}
          getDataFunc={() => getTank({ status: 1 })}
          triggerSetDefaultFunc={true}
          setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, tank: option.find((item) => item.inventory_id === prev.stp?.from_inventory_id) || null }))}
          setDefaultDependencies={[inputData.stp]}
          filter={(item) => item.inventory_id === inputData.stp?.from_inventory_id}
          getOptionLabel={(option) => option.code || ""}
          value={inputData.tank}
          onChange={(e, newValue) => setInputData((prev) => ({ ...prev, tank: newValue }))}
        />
        <FilterBy
          getDataFunc={() => getInventory({ status: 1 })}
          value={inputData.to_inventory}
          setDefaultFunc={(_, option) => setInputData((prev) => ({ ...prev, to_inventory: option.find((item) => item.id === prev.stp?.to_inventory_id) }))}
          setDefaultDependencies={[inputData.stp]}
          triggerSetDefaultFunc={true}
          label={t("Kho nhập")}
          onChange={(e, newValue) => setInputData((prev) => ({ ...prev, to_inventory: newValue }))}
          disabled={Boolean(inputData.stp)}
        />
        <FilterBy
          disabled={Boolean(inputData.stp)}
          label={t("Tên hàng hóa")}
          getDataFunc={() => getProduct({ status: 1 })}
          triggerSetDefaultFunc={true}
          setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, product: option.find((item) => item.id === prev.stp?.product_id) || null }))}
          setDefaultDependencies={[inputData.stp]}
          filter={(item) => item.status === "ACTIVATED"}
          value={inputData.product}
          onChange={(e, newValue) => setInputData((prev) => ({ ...prev, product: newValue }))}
        />
        <FilterBy
          disabled={Boolean(inputData.stp)}
          fullWidth
          label={t("Phương thức vận chuyển")}
          getDataFunc={() => getLoadingType({ status: 1 })}
          setDefaultFunc={(option) => setInputData((prev) => ({ ...prev, loadingtype: option.find((item) => item.code === prev.stp?.loadingtype_id) || null }))}
          setDefaultDependencies={[inputData.stp]}
          triggerSetDefaultFunc={true}
          value={inputData.loadingtype}
          getOptionLabel={(option) => option.name || ""}
          onChange={(e, newValue) => setInputData((prev) => ({ ...prev, loadingtype: newValue }))}
        />
        <FilterBy
          fullWidth
          label={t("Phương tiện")}
          getDataFunc={() => getVehicle({ status: 1, groupvehicle_id: 456230 })}
          setDefaultFunc={(option) => location.state && setInputData((prev) => ({ ...prev, vehicle: option.find((item) => item.license_plate === location.state.receipt.license_plate) }))}
          triggerSetDefaultFunc={location.state}
          value={inputData.vehicle}
          getOptionLabel={(option) => `${option.id} - ${option.license_plate}` || ""}
          onChange={(e, newValue) => setInputData((prev) => ({ ...prev, vehicle: newValue, driver: null, provider_name: newValue.owner_company }))}
        />
        <TextField fullWidth label={t("Người điều khiển")} onChange={(e) => setInputData((prev) => ({ ...prev, driver: e.target.value }))} value={inputData.driver} />
        <CustomDatePicker
          format="DD/MM/YYYY HH:mm"
          outputFormat="YYYY-MM-DD HH:mm"
          label={t("Thời gian bắt đầu")}
          value={inputData.startdate}
          onChange={(value) => setInputData((prev) => ({ ...prev, startdate: value }))}
          sx={{ width: "100%" }}
        />
        <CustomDatePicker
          format="DD/MM/YYYY HH:mm"
          outputFormat="YYYY-MM-DD HH:mm"
          label={t("Thời gian kết thúc")}
          value={inputData.enddate}
          onChange={(value) => setInputData((prev) => ({ ...prev, enddate: value }))}
          sx={{ width: "100%" }}
        />
        <TextField fullWidth label={t("Lệnh xuất kho số ngày")} onChange={(e) => setInputData((prev) => ({ ...prev, orderno: e.target.value }))} value={inputData.orderno} />

        <TextField fullWidth label={t("Chứng chỉ xuất kho số/ngày")} onChange={(e) => setInputData((prev) => ({ ...prev, inventory_cert: e.target.value }))} value={inputData.inventory_cert} />
        <TextField fullWidth label={t("Số/ký hiệu phiếu xuất KDN")} onChange={(e) => setInputData((prev) => ({ ...prev, billcode: e.target.value }))} value={inputData.billcode} />
        <CustomDatePicker
          format="DD/MM/YYYY HH:mm"
          outputFormat="YYYY-MM-DD HH:mm"
          label={t("Ngày xuất phiếu KDN   ")}
          value={inputData.billdate}
          onChange={(value) => setInputData((prev) => ({ ...prev, billdate: value }))}
          sx={{ width: "100%" }}
        />
        <TextField fullWidth label={t("Số hợp đồng")} onChange={(e) => setInputData((prev) => ({ ...prev, contract_no: e.target.value }))} value={inputData.contract_no} />
        <CustomDatePicker
          format="DD/MM/YYYY HH:mm"
          outputFormat="YYYY-MM-DD HH:mm"
          label={t("Ngày hợp đồng")}
          value={inputData.contract_date}
          onChange={(value) => setInputData((prev) => ({ ...prev, contract_date: value }))}
          sx={{ width: "100%" }}
        />
        <FilterBy
          fullWidth
          label={t("Form số")}
          setDefaultFunc={(option) =>
            setInputData((prev) => ({ ...prev, invoiceForm: option.find((item) => (location.state ? item.form === location.state.receipt.form_no : item.id === 3)) || null }))
          }
          triggerSetDefaultFunc
          getDataFunc={() => getInvoiceForm({ status: 1 })}
          value={inputData.invoiceForm}
          getOptionLabel={(option) => `${option.form} - ${option.series}` || ""}
          onChange={(e, newValue) => setInputData((prev) => ({ ...prev, invoiceForm: newValue }))}
        />
        <TextField fullWidth label="Remark" onChange={(e) => setInputData((prev) => ({ ...prev, exp_note: e.target.value }))} value={inputData.exp_note} />
      </div>
      <div style={{ padding: 10, fontSize: 17, backgroundColor: "#f0f3f5", marginTop: 20, textTransform: "uppercase" }}>Thông tin hàng hóa tại kho</div>
      <div style={{ padding: 10, fontSize: 17, backgroundColor: "#FFFFFF", marginTop: 5 }}></div>
      <TableProduct inputData={inputData} setInputData={setInputData} />
      {/* <div style={{ padding: 10, fontSize: 17, backgroundColor: "#f0f3f5", marginTop: 20, textTransform: "uppercase" }}>Thông tin giám định lên tàu</div> */}
      <div style={{ padding: 10, fontSize: 17, backgroundColor: "#FFFFFF", marginTop: 5 }}></div>
      <div align="right" style={{ padding: 5, fontSize: 17, backgroundColor: "#FFFFFF" }}>
        <ButtonGroup variant="contained" size="small" aria-label="small button group">
          {/* button is disabled if required field is empty */}
          <Button onClick={() => setDialogOpen(true)}>Xem trước</Button>
          <ButtonWithAPICallComponent disabled={isSubmitDisabled} api={handleSubmit} response={handleResponse}>
            Tạo phiếu
          </ButtonWithAPICallComponent>
        </ButtonGroup>
      </div>

      {/* hidden stuff */}
      <Dialog scroll="body" PaperProps={{ style: { minWidth: "984px" } }} open={isDialogOpen} onClose={() => setDialogOpen(false)}>
        <TicketPreview data={dataForPreview} />
      </Dialog>
    </Paper>
  );
};

export default CreateB5;

/** Product Table */
const TableProduct = ({ inputData, setInputData }) => {
  // boiler plate
  const [t] = useTranslation();
  const location = useLocation();
  const productRef = useRef();

  // methods
  const handleChangeProduct = (index, keyName, value) => {
    let newProduct = [...inputData.receiptproducts];
    newProduct[index][keyName] = value;
    switch (keyName) {
      case "temp":
        newProduct[index].temp_error = newProduct[index].temp < 4.5 || newProduct[index].temp > 52 ? "4.50 - 52.00" : undefined;
        break;
      case "d15":
        newProduct[index].d15_error = newProduct[index].d15 < 0.65 || newProduct[index].d15 > 1.01 ? "0.6500 - 1.0100" : undefined;
        break;
      case "vcf":
        newProduct[index].vcf_error = newProduct[index].vcf < 0 || newProduct[index].vcf > 1.0184 ? "0.0000 - 1.0184" : undefined;
        break;
      case "wcf":
        newProduct[index].wcf_error = newProduct[index].wcf < 0.6889 || newProduct[index].wcf > 1.0039 ? "0.6889 - 1.0039" : undefined;
        break;
      default:
        break;
    }
    setInputData((prev) => ({ ...prev, receiptproducts: newProduct }));
  };
  // effect
  useEffect(() => {
    productRef.current = inputData.receiptproducts;
  }, [inputData.receiptproducts]);

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t("STT")}</TableCell>
            <TableCell>{t("Tên hàng hóa")}</TableCell>
            <TableCell>{t("Số lượng")}</TableCell>
            <TableCell>{t("Nhiệt độ")} (℃)</TableCell>
            <TableCell>D15</TableCell>
            <TableCell>VCF</TableCell>
            <TableCell>WCF</TableCell>
            <TableCell>
              {t("Số lượng")} ({t("lit")} 15℃)
            </TableCell>
            <TableCell>{t("Số lượng")} (kg)</TableCell>
            {/* <TableCell></TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {inputData.receiptproducts.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{inputData.product?.name}</TableCell>
              <TableCell>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <TextField
                    type="number"
                    variant="outlined"
                    inputProps={{ style: { textAlign: "center" } }}
                    style={{ width: "calc(100% - 100px)", minWidth: 150 }}
                    value={item.quantity}
                    onChange={(e) => handleChangeProduct(index, "quantity", e.target.value)}
                  />
                  <FilterBy
                    getDataFunc={() => getProductUnit({ status: 1 })}
                    value={item.unit}
                    triggerSetDefaultFunc={true}
                    setDefaultFunc={(_, option) =>
                      handleChangeProduct(
                        index,
                        "unit",
                        option.find((item) => (location.state?.receiptproduct[index]?.unit ? item.id === location.state.receiptproduct[index].unit : item.id === 21))
                      )
                    }
                    onChange={(e, newValue) => handleChangeProduct(index, "unit", newValue)}
                    filter={(option) => option.status === "ACTIVATED" && [21, 22, 23].includes(option.id)}
                    style={{ width: 100 }}
                    getOptionLabel={(option) => option.name || ""}
                    label={t("Đơn vị tính")}
                    disableClearable
                  />
                </div>
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  error={Boolean(item.temp_error)}
                  label={item.temp_error}
                  inputProps={{ style: { textAlign: "center" } }}
                  style={{ width: 100 }}
                  value={item.temp}
                  onChange={(e) => handleChangeProduct(index, "temp", e.target.value)}
                />
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  error={Boolean(item.d15_error)}
                  label={item.d15_error}
                  inputProps={{ style: { textAlign: "center" } }}
                  style={{ width: 150 }}
                  value={item.d15}
                  onChange={(e) => handleChangeProduct(index, "d15", e.target.value)}
                />
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  error={Boolean(item.vcf_error)}
                  label={item.vcf_error}
                  inputProps={{ style: { textAlign: "center" } }}
                  style={{ width: 150 }}
                  value={item.vcf}
                  onChange={(e) => handleChangeProduct(index, "vcf", e.target.value)}
                />
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  error={Boolean(item.wcf_error)}
                  label={item.wcf_error}
                  inputProps={{ style: { textAlign: "center" } }}
                  style={{ width: 150 }}
                  value={item.wcf}
                  onChange={(e) => handleChangeProduct(index, "wcf", e.target.value)}
                />
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  error={Boolean(item.l15_error)}
                  label={item.l15_error}
                  inputProps={{ style: { textAlign: "center" } }}
                  style={{ width: 100 }}
                  value={item.l15}
                  onChange={(e) => handleChangeProduct(index, "l15", e.target.value)}
                />
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  error={Boolean(item.kg_error)}
                  label={item.kg_error}
                  inputProps={{ style: { textAlign: "center" } }}
                  style={{ width: 100 }}
                  value={item.kg}
                  onChange={(e) => handleChangeProduct(index, "kg", e.target.value)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
